var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 296.96 80.12982445231711",
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.17 13.47c-2.73-2.66-4.55-6.22-5.23-10.13-.09-.52-.16-1.05-.21-1.57V0h-13.8v54.77c-.02 6.38-5.21 11.55-11.6 11.55-1.88 0-3.65-.45-5.22-1.24a11.585 11.585 0 0 1-6.38-10.36c0-6.4 5.19-11.6 11.6-11.6 1.23 0 2.41.19 3.52.54V29.64c-1.15-.16-2.32-.24-3.48-.24C11.35 29.43 0 40.78 0 54.77c0 8.78 4.46 16.51 11.24 21.06a25.22 25.22 0 0 0 14.12 4.29c14.01 0 25.36-11.35 25.36-25.35V26.78a32.785 32.785 0 0 0 19.12 6.12V19.19c-2.11 0-4.2-.34-6.18-1.01-1.39-.47-4.02-1.31-7.5-4.71z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2 23.03v9.64h11.29v36.72h11.29V32.93h9.19l3.15-9.9zm92.43 0v9.64h11.29v36.72h11.29V32.93h9.19l3.15-9.9zm-55.4 5.47c0-3.02 2.46-5.47 5.51-5.47s5.52 2.45 5.52 5.47-2.47 5.47-5.52 5.47-5.51-2.45-5.51-5.47zm0 9.38h11.02v31.51h-11.02zm15.75-14.85v46.36h11.03V57.41l3.41-3.13 10.76 15.37H178l-15.49-22.4 13.92-13.55h-13.39l-11.03 10.94V23.02h-11.03zm118.95 0v46.36h11.03V57.41l3.41-3.13 10.77 15.37h11.82l-15.49-22.4 13.92-13.55H282l-11.03 10.94V23.02h-11.03zM234.19 69.65c10.59 0 19.17-8.51 19.17-19.01s-8.58-19.01-19.17-19.01h-.26c-10.59 0-19.17 8.51-19.17 19.01s8.58 19.01 19.17 19.01zm-9.45-19.01c0-5.11 4.18-9.24 9.32-9.24s9.32 4.14 9.32 9.24-4.18 9.25-9.32 9.25c-5.15 0-9.32-4.14-9.32-9.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1cd510d24140b3d23ee0f9217e1e927b.svg";
export { ForwardRef as ReactComponent };